import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as ProxyHelper from "../proxyManagement/ProxyHelper";

/**
 * Container component for the Terms Agreement page.
 * 
 */
class TermsAgreement extends React.Component {
    constructor(props) {
        super(props);
        this.handleAcceptClick = this.handleAcceptClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleOKClick = this.handleOKClick.bind(this);
        this.popstate = this.popstate.bind(this);
    }

    componentDidMount() {
        const { useOnboardingLayout } = this.props;
        if (typeof window !== 'undefined') {
            this.popstate();
            window.addEventListener('popstate', this.popstate);
        }
        logUI(`MBHWeb.UI.TermsAgreement.ComponentDidMount${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined' && this.popstate)
            window.removeEventListener('popstate', this.popstate);
    }

    popstate() {
        if (typeof window !== 'undefined') {
            window.history.pushState(null, document.title, window.location.href);
        }
    }

    handleAcceptClick(event) {
        event.preventDefault();
        const { acknowledgeTerms, termsVersion, useOnboardingLayout } = this.props;
        acknowledgeTerms(termsVersion);

        logUI(`MBHWeb.TermsConditions.Accept${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.leavePage()
    }

    handleCancelClick(event) {
        event.preventDefault();
        const { useOnboardingLayout } = this.props;
        this.props.logout("You must accept the terms and conditions to access this site.");

        logUI(`MBHWeb.TermsConditions.Cancel${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    handleOKClick(event) {
        const { useOnboardingLayout } = this.props;
        logUI(`MBHWeb.TermsConditions.OK${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.leavePage();

    }

    leavePage = () => {
        const { showInsuranceForm, showEmailOptIn, showNotificationsScreen, reDirectUrl, useOnboardingLayout} = this.props;

        try {
            if (reDirectUrl && reDirectUrl !== "/"
                && reDirectUrl !== '/emailoptin'
                && reDirectUrl !== '/onboarding/captureinsurance'
                && reDirectUrl !== '/onboarding/managenotifications') {
                logUI(`MBHWeb.TermsConditions.LoadRedirectUrl${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
                this.props.history.push(redirectURL);
            } else if (showEmailOptIn || reDirectUrl === '/emailoptin') {
                logUI(`MBHWeb.TermsConditions.LoadEmailOptIn${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
                this.props.history.push("/emailoptin");
            } else if (showInsuranceForm || reDirectUrl === '/onboarding/captureinsurance') {
                logUI(`MBHWeb.TermsConditions.LoadInsuranceForm${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
                this.props.history.push("/onboarding/captureinsurance");
            } else if (showNotificationsScreen || reDirectUrl === '/onboarding/managenotifications') {
                logUI(`MBHWeb.TermsConditions.LoadManageNotifications${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
                this.props.history.push("/onboarding/managenotifications");
            }
            else {
                //debugger;
                this.props.history.push("/");
            }
        }
        catch (e) {
            //debugger;
            window.location.href = "/";
        }
    }


    render() {
        const { userHasAccepted, termsObject } = this.props;
        return (
            <div className="container-fluid  terms-agreement-container">
                <div className="row terms-agreement__body">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                {termsObject &&
                                    <div className="terms-text">
                                        <div dangerouslySetInnerHTML={{ __html: termsObject }} />
                                       
                                    </div>
                                }
                                {/* Terms text becomes hidden after successfully accepted terms 
                                */}
                            </div>
                        </div>
                        <div className="row terms-agreement__footer">
                            <div className="col-12 text-center maxWidth-content">
                                {/* Accept and decline buttons become hidden after user declines or accepts terms */}
                                {!userHasAccepted 
                                    ?
                                    <div className="row">
                                        <>
                                            <div className="col-12">
                                                <a className="btn btn-primary" href="#" onClick={(e) => this.handleAcceptClick(e)}>ACCEPT</a>
                                            </div>
                                            <div className="col-12">
                                                <a className="btn text-btn" href="#" onClick={(e) => this.handleCancelClick(e)}>DECLINE</a>
                                            </div>
                                        </>
                                    </div>
                                    : <div className="row">
                                        <div className="col-12 col-sm-4 offset-sm-4 form-group">
                                            {<a className="btn btn-primary" href="#" onClick={(e) => this.handleOKClick(e)}>OKAY</a>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    //debugger;
    return {
        userHasAccepted: state.session.userHasAccepted,
        termsVersion: state.session.version,
        history: state.session.history,
        termsObject: state.session.terms, // ? JSON.parse(state.session.terms) : null,
        showInsuranceForm: state.session.showInsuranceForm,
        showEmailOptIn: state.session.showEmailOptIn,
        showNotificationsScreen: state.session.showNotificationsScreen,
        reDirectUrl: window.redirectURL,
        useOnboardingLayout: state.session.useOnboardingLayout
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        acknowledgeTerms: (version) => {
            //debugger;
            dispatch({
                type: types.ACCEPT_TERMS_AND_CONDITIONS,
                VersionID: version
            });

        },
        logout: (message) => {
            dispatch({
                type: types.LOGOUT,
                logoutMessage: message
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsAgreement);